module.exports = __webpack_public_path__ + "img/new.5d68398c.png";